export interface IActionBase {
    type: string
}

export interface IAction<T> extends IActionBase {
    payload: T
}

export enum ArrayState {
    NotSorted,
    Sorting,
    Sorted,
}
